import { render, staticRenderFns } from "./RefundAccountStep.vue?vue&type=template&id=2a7872bc&scoped=true&"
import script from "./RefundAccountStep.vue?vue&type=script&lang=ts&"
export * from "./RefundAccountStep.vue?vue&type=script&lang=ts&"
import style0 from "./RefundAccountStep.vue?vue&type=style&index=0&id=2a7872bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7872bc",
  null
  
)

export default component.exports